// "use client";
// import { useGlobalContext } from "@/context/store";
// import { useContracts } from "@/lib/contract";
// import { formatUnits } from "ethers";
// import { useEffect, useRef, useState } from "react";
// import { useAccount } from "wagmi";
// import NewProgramCard from "./components/unstack/NewProgramCard";
// import StakeInfo from "./components/unstack/StakeInfo";
// import UnstakeCard from "./components/unstack/UnstakeCard";
// import WarningBanner from "./components/unstack/WarningBanner";


// export default function Home() {
//   const { tokenContract, stakingContract } = useContracts();
//   const { address, isConnected } = useAccount();
//   const { setAccountBalance, accountBalance } = useGlobalContext();

//   const [isLoading, setIsLoading] = useState(false);

//   const lastFetchedAddress = useRef<string | null>(null);

//   function truncateToTwoDecimals(num: number | string) {
//     const str = typeof num === "number" ? num.toString() : num;
//     const [intPart, decimalPart = ""] = str.split(".");
//     return `${intPart}.${decimalPart.slice(0, 3).padEnd(3, "0")}`;
//   }

//   const fetchBalance = async () => {
//     setIsLoading(true);

//     try {
//       const rawBalance = await tokenContract?.read.balanceOf([address]);
//       const formatted = formatUnits(rawBalance as bigint, 18);

//       const rawUnStake: any = await stakingContract?.read.stakes([address]);
//       const unStake = rawUnStake
//         ? formatUnits(rawUnStake[0] as bigint, 18)
//         : "0";

//       const rawClaimable: any = await stakingContract?.read.earned([address]);
//       const claimable = rawClaimable
//         ? formatUnits(rawClaimable as bigint, 18)
//         : "0";

//       setAccountBalance({
//         staking: truncateToTwoDecimals(formatted),
//         unstake: truncateToTwoDecimals(unStake),
//         reward: truncateToTwoDecimals(claimable),
//       });
//     } catch (err) {
//       console.error("Error fetching balances:", err);
//       setAccountBalance({
//         staking: "0",
//         unstake: "0",
//         reward: "0",
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (
//       isConnected &&
//       address &&
//       tokenContract &&
//       stakingContract &&
//       lastFetchedAddress.current !== address
//     ) {
//       lastFetchedAddress.current = address;
//       fetchBalance();
//     }
//   }, [isConnected, address, tokenContract, stakingContract]);

//   // Reset states on disconnect
//   useEffect(() => {
//     if (!isConnected || !address) {
//       lastFetchedAddress.current = null;
//       setAccountBalance({
//         staking: "0",
//         unstake: "0",
//         reward: "0",
//       });
//     }
//   }, [isConnected, address]);


//   return (
//     <main className="min-h-screen  text-white p-6 mt-20 md:mt-24 lg:mt-28">
//       <div className="max-w-7xl mx-auto space-y-8">
//         <WarningBanner />
//         <div className="grid lg:grid-cols-3 lg:gap-6">
//           <div className="lg:col-span-2 space-y-6 mb-6 lg:mb-0">
//             <StakeInfo unstackAmount={accountBalance.unstake || "0"} />
//             <NewProgramCard />
//           </div>
//           <div className="col-span-3 lg:col-span-1 space-y-6">
//             <UnstakeCard data={{ unstackAmount: accountBalance.unstake || "0" }} onSuccess={fetchBalance} address={address} />
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }



"use client";
import { useGlobalContext } from "@/context/store";
import { useContracts } from "@/lib/contract";
import { formatUnits } from "ethers";
import { useEffect, useRef, useState } from "react";
import { useAccount } from "wagmi";
import NewProgramCard from "./components/unstack/NewProgramCard";
import StakeInfo from "./components/unstack/StakeInfo";
import UnstakeCard from "./components/unstack/UnstakeCard";
import WarningBanner from "./components/unstack/WarningBanner";

function MaintenanceModal() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-neutral-900 p-6 sm:p-8 text-center shadow-2xl">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-yellow-500/10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-yellow-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m0 3.75h.007v.008H12v-.008zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-white mb-2">
          Wartungsarbeiten
        </h2>
        <p className="text-sm text-neutral-400 leading-relaxed">
          Wir führen derzeit einen umfassenden technischen Systemabgleich durch. Aus diesem Grund ist das Unstaking-Portal vorübergehend pausiert.
Ihre Guthaben und Ansprüche sind davon selbstverständlich nicht betroffen und bleiben vollumfänglich bestehen.
Wir arbeiten mit Hochdruck daran, den Service so schnell wie möglich wieder bereitzustellen, und informieren Sie hier sowie über unseren Telegram-Kanal, sobald das Portal wieder verfügbar ist.
Vielen Dank für Ihr Verständnis und Ihre Geduld.
        </p>
      </div>
    </div>
  );
}

export default function Home() {
  const { tokenContract, stakingContract } = useContracts();
  const { address, isConnected } = useAccount();
  const { setAccountBalance, accountBalance } = useGlobalContext();

  const [isLoading, setIsLoading] = useState(false);

  const lastFetchedAddress = useRef<string | null>(null);

  function truncateToTwoDecimals(num: number | string) {
    const str = typeof num === "number" ? num.toString() : num;
    const [intPart, decimalPart = ""] = str.split(".");
    return `${intPart}.${decimalPart.slice(0, 3).padEnd(3, "0")}`;
  }

  const fetchBalance = async () => {
    setIsLoading(true);

    try {
      const rawBalance = await tokenContract?.read.balanceOf([address]);
      const formatted = formatUnits(rawBalance as bigint, 18);

      const rawUnStake: any = await stakingContract?.read.stakes([address]);
      const unStake = rawUnStake
        ? formatUnits(rawUnStake[0] as bigint, 18)
        : "0";

      const rawClaimable: any = await stakingContract?.read.earned([address]);
      const claimable = rawClaimable
        ? formatUnits(rawClaimable as bigint, 18)
        : "0";

      setAccountBalance({
        staking: truncateToTwoDecimals(formatted),
        unstake: truncateToTwoDecimals(unStake),
        reward: truncateToTwoDecimals(claimable),
      });
    } catch (err) {
      console.error("Error fetching balances:", err);
      setAccountBalance({
        staking: "0",
        unstake: "0",
        reward: "0",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      isConnected &&
      address &&
      tokenContract &&
      stakingContract &&
      lastFetchedAddress.current !== address
    ) {
      lastFetchedAddress.current = address;
      fetchBalance();
    }
  }, [isConnected, address, tokenContract, stakingContract]);

  // Reset states on disconnect
  useEffect(() => {
    if (!isConnected || !address) {
      lastFetchedAddress.current = null;
      setAccountBalance({
        staking: "0",
        unstake: "0",
        reward: "0",
      });
    }
  }, [isConnected, address]);

  return (
    <main className="min-h-screen  text-white p-6 mt-20 md:mt-24 lg:mt-28">
      <MaintenanceModal />
      <div className="max-w-7xl mx-auto space-y-8">
        <WarningBanner />
        <div className="grid lg:grid-cols-3 lg:gap-6">
          <div className="lg:col-span-2 space-y-6 mb-6 lg:mb-0">
            <StakeInfo unstackAmount={accountBalance.unstake || "0"} />
            <NewProgramCard />
          </div>
          <div className="col-span-3 lg:col-span-1 space-y-6">
            <UnstakeCard data={{ unstackAmount: accountBalance.unstake || "0" }} onSuccess={fetchBalance} address={address} />
          </div>
        </div>
      </div>
    </main>
  );
}